import React, {PureComponent} from 'react';

class AutoFocusedInput extends PureComponent {
    componentDidMount() {
      this._input.focus();
    }

    render() {
        return (
            <input {...this.props} ref={(c) => this._input = c} />
        );
    }

    getValue() {
        return this._input && this._input.value;
    }
} 
export default AutoFocusedInput;